import React from 'react';

import * as styles from './Stack.module.scss';

const Stack = ({ spaced, ...rest }) => (
  <div className={styles[`spaceY${spaced}`]} {...rest} />
);

export default Stack;
